import React, { useEffect, useState } from 'react';
import Sidebar from '../../components/Admin/Sidebar';
import * as Icon from 'react-bootstrap-icons';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { getCategories } from './AllCategories';

const AllSubCategories = () => {
    // Get all categories from all categories
    const getData = getCategories;

    // Authentication
    const authtoken = localStorage.getItem('token');
    const token = `Bearer ${authtoken}`;

    const [toggleValue, setToggleValue] = useState(false);
    const [show, setShow] = useState(false);
    const [defaultCategory, setDefaultCategory] = useState('')
    const [subcategory, setSubCategory] = useState('')
    const [categories, setCategories] = useState([])
    const [subcategories, setSubcategories] = useState([])
    const [selectedCategory, setSelectedCategory] = useState('')

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const categoryData = await getData();
                setCategories(categoryData.categories);
                if (categoryData.categories.length > 0) {
                    const firstCategoryName = categoryData.categories[0].name;
                    setSelectedCategory(firstCategoryName); // Set the first category as the default
                }
            } catch (error) {
                console.error('Failed to fetch categories:', error);
            }
        };

        fetchCategories();
    }, [getData]);

    useEffect(() => {
        if (selectedCategory) {
            showSubcategoris();
        }
    }, [selectedCategory]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (defaultCategory === '' && subcategory === '') {
            toast.error("Please select a category and add a subcategory!");
            return;
        }

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}product/subcategories/add`, { "name": subcategory, "categoryId": defaultCategory }, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            });

            const message = response.data.message;
            const status = response.data.status;

            if (status === "error") {
                toast.warn(message);
            } else {
                toast.success("Subcategory successfully uploaded");
                setSubCategory('');
                setDefaultCategory('');
                showSubcategoris();
            }

        } catch (error) {
            toast.error('Error:', error);
        }
    };

    const showSubcategoris = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}product/subcategories?categoryname=${selectedCategory}`);
            setSubcategories(response.data.subcategories);
        } catch (error) {
            console.error("Error: " + error);
            setSubcategories([]);
        }
    };

    return (
        <>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 p-0'>
                        <Sidebar toggleSidebar={toggleValue} setToggleValue={setToggleValue} />
                    </div>
                    <div className='col-lg-10 p-lg-5 p-md-4 mt-lg-5 mt-md-3 mt-3 dashboard-wrapper'>
                        <Icon.ArrowRight onClick={() => setToggleValue(true)} className='my-5 sidebar-open' color='black' size={30} />
                        <div className='row dashboard-content mt-lg-0 mt-md-3 mt-3'>
                            {/* <div className="col-12">
                                <h5>Sub Categories</h5>
                                <h6 className='text-muted'>View & add sub categories</h6>
                            </div> */}
                            <div className='col-12 my-0'>
                                <div className='row'>
                                    <div className='col-lg-9 col-md-8 col-6'>
                                        {/* <Button variant="success" onClick={handleShow}>Add subcategory<Icon.PlusCircle className='ms-2' /></Button> */}
                                        <h5>Sub Categories</h5>
                                        <h6 className='text-muted'>View & add sub categories</h6>
                                    </div>
                                    <div className='col-lg-3 col-md-4 col-6 text-lg-end'>
                                        {/* <Form.Control
                                            type="text"
                                            placeholder="Search products"
                                            className="mr-sm-2 shadow-none"
                                        /> */}
                                        <Button variant="success" onClick={handleShow}>Add subcategory<Icon.PlusCircle className='ms-2' /></Button>

                                    </div>
                                </div>
                                <div className='mt-5'>
                                    <div className='row'>
                                        <div className='col-lg-4'>
                                            <Form.Select aria-label="Default select example" value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)}>
                                                {
                                                    categories.map((category) => (
                                                        <option key={category.id} value={category.name}>{category.name}</option>
                                                    ))
                                                }
                                            </Form.Select>
                                        </div>
                                    </div>
                                    {/* Display subcategories */}
                                    <div className='mt-4'>
                                        <div className="row">
                                            {subcategories.length > 0 ? subcategories.map((subcategory, i) => (
                                                <div key={i} className="col-lg-2 col-md-4 col-6 mb-lg-3 mb-md-3 mb-3">
                                                    <div className='card p-3 shadow w-100'>
                                                        {subcategory.name}
                                                    </div>
                                                </div>
                                            ))
                                                :
                                                <div>No subcategories</div>
                                            }
                                        </div>
                                    </div>
                                    {/* Display subcategories */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add category modal */}
            <Modal show={show} onHide={handleClose} size="lg">
                <form onSubmit={handleSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title><Icon.Tags color='black' size={40} /></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-lg-6">
                                <Form.Select aria-label="Default select example" onChange={(e) => setDefaultCategory(e.target.value)}>
                                    <option selected disabled>Select a category</option>
                                    {
                                        categories.map((category) => (
                                            <option key={category.id} value={category.id}>{category.name}</option>
                                        ))
                                    }
                                </Form.Select>
                            </div>
                            <div className="col-lg-6">
                                <input type="text" value={subcategory} onChange={(e) => setSubCategory(e.target.value)} placeholder='Enter your subcategory' className='form-control shadow-none' disabled={defaultCategory === ''} />
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="success" type="submit" className='shadow-none' onClick={handleClose}>
                            Add category
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>

            <ToastContainer theme="dark" autoClose={2000} />
        </>
    );
};

export default AllSubCategories;
